import React, { ReactNode } from 'react';
import Box from '../Box/Box';

type THubBaseProps = {
  as?: string;
  kind: 'nav' | 'field';
  children: ReactNode;
};

// oxlint-disable-next-line no-unused-vars
const HubBase = ({ as = 'div', kind, ...props }: THubBaseProps) => (
  <Box {...props} name="Hub" as="div" modifiers={kind} />
);

export default HubBase;
